import { takeEvery, put, call, select } from "redux-saga/effects"
//******************************************************************************
// ***************************** CONSTANTS *************************************
//******************************************************************************
import {
  GET_ACTIVITY,
  GET_ACTIVITY_SUCCESS,
  GET_ACTIVITY_BY_ID,
  GET_ACTIVITY_BY_ID_SUCCESS,
  POST_ACTIVITY,
  POST_ACTIVITY_SUCCESS,
  PATCH_ACTIVITY_BY_ID,
  PATCH_ACTIVITY_BY_ID_SUCCESS,
  DELETE_ACTIVITY_BY_ID,
  DELETE_ACTIVITY_BY_ID_SUCCESS,
} from "../Activity/constants.js"
//******************************************************************************
// ***************************** ACTIONS ***************************************
//******************************************************************************
import {
  getActivityAction,
  getActivitySuccess,
  getActivityByIdAction,
  getActivityByIdSuccess,
  postActivityAction,
  postActivitySuccess,
  patchActivityByIdAction,
  deleteActivityByIdAction,
} from "../Activity/actions.js"

import { setLoaderDataAction } from "../Templates/actions.js"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"


// Utils
import request from "Utils/request"
import { config } from "Utils/config"
import { getCors, postCors, postFileCors, patchCors, deleteCors } from "Utils/rulesCors"
// Actions

import {
  setSuccessMessage,
  setErrorMessage,
  removeErrorMessage,
  removeSuccessMessage,
} from "Containers/Messages/actions"

import { selectCurrentToken } from "Containers/Login/selectors.js"
//**********************************************************************************************
//***************************************** SAGA  **********************************************
//**********************************************************************************************
//GET_ACTIVITY
function* getAllActivitySaga({ payload }) {
  const exclude = payload?.exclude
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/activity?exclude=${exclude}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getActivitySuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /activity => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//GET_ACTIVITY_BY_ID
function* getActivityByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { activityId } = payload
  const requestURL = `${FORM_BACK_URL}/activity/${activityId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getActivityByIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /activity/:listId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// POST_ACTIVITY
function* postActivitySaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { activityToCreate } = payload
  const requestURL = `${FORM_BACK_URL}/activity`

  try {
    const response = yield call(request, requestURL, postCors(activityToCreate, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getActivityAction({ exclude: "archived" }))
        yield put(postActivitySuccess(response.body))
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /activity => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// PATCH_ACTIVITY_BY_ID
function* patchActivityByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { activityToUpdate, activityId } = payload
  const requestURL = `${FORM_BACK_URL}/activity/${activityId}`

  try {
    const response = yield call(request, requestURL, patchCors(activityToUpdate, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getActivityAction({ exclude: "archived" }))
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /activity => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// DELETE ACTIVITY
function* deleteActivitySaga({ payload }) {
  const activityId = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `activity/${activityId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getActivityAction({ exclude: "archived" }))
      }
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* activitySaga() {
  yield takeEvery(GET_ACTIVITY, getAllActivitySaga)
  yield takeEvery(GET_ACTIVITY_BY_ID, getActivityByIdSaga)
  yield takeEvery(POST_ACTIVITY, postActivitySaga)
  yield takeEvery(PATCH_ACTIVITY_BY_ID, patchActivityByIdSaga)
  yield takeEvery(DELETE_ACTIVITY_BY_ID, deleteActivitySaga)
}

export default activitySaga
